import React, { Component } from 'react'
import { Eye } from 'react-feather'
import { Container } from './styles'

class Seen extends Component {
  render() {
    return(
      <Container>
        <Eye size={'100%'} />
      </Container>
    )
  }
}

export default Seen



// WEBPACK FOOTER //
// ./src/Components/Seen/index.js